import styled from 'styled-components';
import { Button } from 'antd';

export const FavouriteStarButton = styled(Button)<{ $isFavourite: boolean }>`
  .star-filled,
  .star-outlined {
    color: ${({ $isFavourite, theme: { token } }) => ($isFavourite ? token.colorYellowActive : token.colorIcon)};
    &:hover {
      color: ${({ $isFavourite, theme: { token } }) => ($isFavourite ? token.colorYellowActive : token.colorIcon)};
    }
  }
`;
